import React, { useState, useEffect, useRef, useContext } from 'react';
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import Button from "components/CustomButtons/Button.js";
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import AlertDialog from '../components/AlertDialog';
import { FirebaseContext, api } from 'common';
import { useTranslation } from "react-i18next";
import moment from 'moment';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
  List,
  ListItemButton,
  ListItemText
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  pageContainer: {
    display: 'flex',
    minHeight: 'calc(100vh - 100px)',
    backgroundColor: '#FFFFFF',
  },
  sidebar: {
    width: 240,
    borderRight: '1px solid #E5E7EB',
    paddingTop: 24,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  sidebarItem: {
    padding: '12px 24px',
    cursor: 'pointer',
    fontSize: 14,
    color: '#000',
    borderLeft: '3px solid transparent',
    '&:hover': {
      backgroundColor: '#F9FAFB',
    },
  },
  sidebarItemActive: {
    padding: '12px 24px',
    cursor: 'pointer',
    fontSize: 14,
    fontWeight: 500,
    color: '#000',
    borderLeft: '3px solid #000',
    backgroundColor: '#F9FAFB',
  },
  mainContent: {
    flex: 1,
    padding: '24px 48px',
    maxWidth: 680,
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
    },
  },
  pageTitle: {
    fontSize: 36,
    fontWeight: 700,
    color: '#000',
    marginBottom: 32,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  profilePhoto: {
    width: 96,
    height: 96,
    borderRadius: '50%',
    objectFit: 'cover',
    cursor: 'pointer',
    marginBottom: 32,
    border: '2px solid #E5E7EB',
  },
  infoRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 0',
    borderBottom: '1px solid #E5E7EB',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#FAFAFA',
      marginLeft: -16,
      marginRight: -16,
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  infoRowLast: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px 0',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#FAFAFA',
      marginLeft: -16,
      marginRight: -16,
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  infoLabel: {
    fontSize: 14,
    fontWeight: 500,
    color: '#000',
    marginBottom: 4,
  },
  infoValue: {
    fontSize: 14,
    color: '#6B7280',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  verifiedIcon: {
    color: '#22C55E',
    fontSize: 16,
  },
  chevronIcon: {
    color: '#9CA3AF',
    fontSize: 20,
  },
  externalIcon: {
    color: '#9CA3AF',
    fontSize: 18,
  },
  rootRtl: {
    "& label": {
      right: 10,
      left: "auto",
      paddingRight: 20
    },
    "& legend": {
      textAlign: "right",
      marginRight: 20
    }
  },
  rootRtl_1: {
    "& label": {
      right: 10,
      left: "auto",
      paddingRight: 33
    },
    "& legend": {
      textAlign: "right",
      marginRight: 25
    }
  },
  editModal: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: 24,
    maxWidth: 400,
    width: '100%',
  },
  saveButton: {
    width: '100%',
    height: 48,
    borderRadius: 8,
    backgroundColor: '#000',
    color: '#fff',
    fontWeight: 600,
    textTransform: 'none',
    marginTop: 16,
    '&:hover': {
      backgroundColor: '#1F2937',
    },
  },
  cancelButton: {
    width: '100%',
    height: 48,
    borderRadius: 8,
    backgroundColor: '#F3F4F6',
    color: '#000',
    fontWeight: 600,
    textTransform: 'none',
    marginTop: 8,
    '&:hover': {
      backgroundColor: '#E5E7EB',
    },
  },
}));

const MyProfile = () => {
  const { authRef, RecaptchaVerifier } = useContext(FirebaseContext);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const {
    updateProfile,
    updateWebProfileImage,
    requestEmailOtp,
    updateAuthEmail
  } = api;
  const auth = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });
  const languagedata = useSelector(state => state.languagedata);
  const [langSelection, setLangSelection] = useState(0);
  const [multiLanguage,setMultiLanguage] = useState();
  const fileInputRef=useRef();
  const [selectedImage, setSelectedImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  
  const [data, setData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    usertype: '',
    verifyId: ''
  });

  const [otp,setOtp] = useState("");
  const [otpCalled,setOtpCalled] = useState(false);
  const [updateCalled,setUpdateCalled] = useState(false);
  const [confirmCodeFunction,setConfirmCodeFunction] = useState();
  const [activeTab, setActiveTab] = useState(0);
  const [editField, setEditField] = useState(null);
  const [editValue, setEditValue] = useState('');
  const formTopRef = useRef(null);
 
  useEffect(()=>{
    if(languagedata.langlist){
      let arr = Object.keys(languagedata.langlist);
      for (let i=0; i< arr.length; i++) {
        if(auth.profile && auth.profile.lang && auth.profile.lang.langLocale && auth.profile.lang.langLocale === languagedata.langlist[arr[i]].langLocale){
          setLangSelection(i);
        }
      }
      setMultiLanguage(languagedata.langlist);
    }
  },[languagedata.langlist,auth.profile,setMultiLanguage,setLangSelection]);

  useEffect(() => {
    if (auth.profile && auth.profile.uid) {
      setData({
        firstName: auth.profile.firstName,
        lastName: auth.profile.lastName,
        email: auth.profile.email,
        mobile: auth.profile.mobile,
        usertype: auth.profile.usertype,
        profile_image: auth.profile.profile_image ?  auth.profile.profile_image : '',
        verifyId: auth.profile.verifyId ?  auth.profile.verifyId : ''
      });
      if(updateCalled){
        setLoading(false);
        setCommonAlert({ open: true, msg: t('profile_updated') });
        setUpdateCalled(false);
      }
    }

  }, [auth.profile, t, updateCalled]);

  const completeSubmit = () => {
    setUpdateCalled(true);
    let arr = Object.keys(languagedata.langlist);
    dispatch(updateProfile({
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      mobile: data.mobile,
      verifyId: data.verifyId,
      lang: {langLocale: multiLanguage[arr[langSelection]].langLocale, dateLocale:multiLanguage[arr[langSelection]].dateLocale }
    }));

    if(selectedImage){
      updateWebProfileImage(selectedImage);
    }

    const lang = multiLanguage[arr[langSelection]];
    i18n.addResourceBundle(
      multiLanguage[arr[langSelection]].langLocale,
      'translations',
      multiLanguage[arr[langSelection]].keyValuePairs,
      true,
      true
    );
    i18n.changeLanguage(lang.langLocale);
    moment.locale(lang.dateLocale);
    setSelectedImage(null);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(data.email!==auth.profile.email && data.mobile!==auth.profile.mobile){
      setCommonAlert({ open: true, msg: t('update_any') })
    } else {
      if( data.firstName && data.firstName.length > 0 && data.lastName && data.lastName.length > 0){
        if(data.email!==auth.profile.email ){
          const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if(re.test(data.email)){
            setOtpCalled(true);
            dispatch(requestEmailOtp(data.email));
          } else {
            setCommonAlert({ open: true, msg: t('proper_email') })
          }
        } else if(data.mobile!==auth.profile.mobile ){
          if(data.mobile && data.mobile.length > 6){
            setOtpCalled(true);
            window.recaptchaVerifier = new RecaptchaVerifier("sign-in-button",{
              'size': 'invisible'
            });
            if(auth.profile.mobile && auth.profile.mobile.length>6){
              await authRef.currentUser.unlink("phone")
            }
            const linkObj = await authRef.currentUser.linkWithPhoneNumber(data.mobile, window.recaptchaVerifier);
            setConfirmCodeFunction(linkObj);
          } else {
            setCommonAlert({ open: true, msg: t('mobile_no_blank_error') })
          }
        } else{
          setLoading(true);
          completeSubmit();
        }
      } else{
        setCommonAlert({ open: true, msg: t('no_details_error') })
      }
    }
  }

  const updateOtp = (e) => {
    setOtp(e.target.value);
  }

  const handleVerify = async () => {
    if(otp && otp.length === 6 && !isNaN(otp)){
      setLoading(true);
      if(confirmCodeFunction){
        confirmCodeFunction.confirm(otp).then((user)=>{
            completeSubmit()
        }).catch((error)=>{
            setOtp('');
            setLoading(false);
            window.recaptchaVerifier.clear();
            setCommonAlert({ open: true, msg: t('otp_validate_error')})
        })
      }else{
        const res = await updateAuthEmail(data.email,otp);
        if(res.success){
          completeSubmit()
        }else{
          setOtp('');
          setLoading(false);
          if(res.error === 'Error updating user'){
              setCommonAlert({ open: true, msg: t('user_exists')})
          }else{
              setCommonAlert({ open: true, msg: t('otp_validate_error')})
          }
        }
      }
    } else{
      setOtp('');
      setCommonAlert({ open: true, msg: t('otp_validate_error')})
    }
    setOtpCalled(false);
    window.recaptchaVerifier = null;
  }

  const handleClose = () => {
    setOtp('');
    setOtpCalled(false);
    window.recaptchaVerifier = null;
  }

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  const handleLanguageSelect = (event) => {
    setLangSelection(event.target.value);
  };

  const profileImageChange = async (e)=>{
    setSelectedImage( e.target.files[0]);
  }

  const openEditModal = (field, value) => {
    setEditField(field);
    setEditValue(value || '');
  };

  const closeEditModal = () => {
    setEditField(null);
    setEditValue('');
  };

  const saveEditField = () => {
    if (editField === 'name') {
      const parts = editValue.split(' ');
      setData({ ...data, firstName: parts[0] || '', lastName: parts.slice(1).join(' ') || '' });
    } else if (editField === 'email') {
      setData({ ...data, email: editValue });
    } else if (editField === 'mobile') {
      setData({ ...data, mobile: editValue });
    }
    closeEditModal();
  };

  const sidebarItems = [
    { id: 'home', label: t('home') || 'Home', path: '/dashboard' },
    { id: 'personal', label: t('personal_info') || 'Personal info', tab: 0 },
    { id: 'security', label: t('security') || 'Security', tab: 1 },
    { id: 'privacy', label: t('privacy_data') || 'Privacy & data', tab: 2 },
  ];

  const getCurrentLanguageName = () => {
    if (multiLanguage && langSelection !== undefined) {
      const keys = Object.keys(multiLanguage);
      if (keys[langSelection]) {
        return multiLanguage[keys[langSelection]].langName;
      }
    }
    return t('update_device_language') || 'Update device language';
  };

  return (
    auth.loading ? <CircularLoading /> :
      <Box className={classes.pageContainer} style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}>
        <CssBaseline />
        <div id="sign-in-button" />

        {/* Sidebar */}
        <Box className={classes.sidebar}>
          {sidebarItems.map((item) => (
            <Box
              key={item.id}
              className={activeTab === item.tab ? classes.sidebarItemActive : classes.sidebarItem}
              onClick={() => item.path ? navigate(item.path) : setActiveTab(item.tab)}
            >
              {item.label}
            </Box>
          ))}
        </Box>

        {/* Main Content */}
        <Box className={classes.mainContent}>
          {activeTab === 0 && (
            <>
              <Typography className={classes.pageTitle}>
                {t('personal_info') || 'Personal info'}
              </Typography>

              {/* Profile Photo */}
              <Box onClick={() => fileInputRef.current.click()}>
                {selectedImage ? (
                  <img src={URL.createObjectURL(selectedImage)} alt='Profile' className={classes.profilePhoto} />
                ) : data.profile_image ? (
                  <img src={data.profile_image} alt='Profile' className={classes.profilePhoto} />
                ) : (
                  <img src={require("../assets/img/profilePic.png").default} alt='Profile' className={classes.profilePhoto} />
                )}
              </Box>
              <input onChange={(event) => profileImageChange(event)} multiple={false} ref={fileInputRef} type='file' hidden />

              {/* Name Row */}
              <Box className={classes.infoRow} onClick={() => openEditModal('name', `${data.firstName} ${data.lastName}`)}>
                <Box>
                  <Typography className={classes.infoLabel}>{t('name') || 'Name'}</Typography>
                  <Typography className={classes.infoValue}>
                    {data.firstName} {data.lastName}
                  </Typography>
                </Box>
                <ChevronRightIcon className={classes.chevronIcon} />
              </Box>

              {/* Phone Row */}
              <Box className={classes.infoRow} onClick={() => openEditModal('mobile', data.mobile)}>
                <Box>
                  <Typography className={classes.infoLabel}>{t('phone') || 'Phone number'}</Typography>
                  <Typography className={classes.infoValue}>
                    {data.mobile || t('add_phone') || 'Add phone number'}
                    {data.mobile && <CheckCircleIcon className={classes.verifiedIcon} />}
                  </Typography>
                </Box>
                <ChevronRightIcon className={classes.chevronIcon} />
              </Box>

              {/* Email Row */}
              <Box className={classes.infoRow} onClick={() => openEditModal('email', data.email)}>
                <Box>
                  <Typography className={classes.infoLabel}>{t('email') || 'Email'}</Typography>
                  <Typography className={classes.infoValue}>
                    {data.email || t('add_email') || 'Add email'}
                    {data.email && <CheckCircleIcon className={classes.verifiedIcon} />}
                  </Typography>
                </Box>
                <ChevronRightIcon className={classes.chevronIcon} />
              </Box>

              {/* Language Row */}
              <Box className={classes.infoRowLast} onClick={() => openEditModal('language', '')}>
                <Box>
                  <Typography className={classes.infoLabel}>{t('language') || 'Language'}</Typography>
                  <Typography className={classes.infoValue}>
                    {getCurrentLanguageName()}
                  </Typography>
                </Box>
                <OpenInNewIcon className={classes.externalIcon} />
              </Box>

              {/* Hidden submit for form functionality */}
              <form onSubmit={handleSubmit} style={{ display: 'none' }}>
                <button type="submit" ref={formTopRef} />
              </form>
            </>
          )}

          {activeTab === 1 && (
            <>
              <Typography className={classes.pageTitle}>
                {t('security') || 'Security'}
              </Typography>
              <Typography variant="body1" sx={{ color: '#6B7280', lineHeight: 1.7, mb: 3 }}>
                {t('security_info') || 'You can change your email or phone in Personal info. For your security, we verify changes with a one‑time code (OTP).'}
              </Typography>
              <Typography variant="body1" sx={{ color: '#6B7280', lineHeight: 1.7 }}>
                {t('tip_strong_password') || "Tip: Use a strong password on your mobile app account and don't share one-time codes with anyone."}
              </Typography>
            </>
          )}

          {activeTab === 2 && (
            <>
              <Typography className={classes.pageTitle}>
                {t('privacy_data') || 'Privacy & data'}
              </Typography>
              <Typography variant="body1" sx={{ color: '#6B7280', lineHeight: 1.7 }}>
                {t('privacy_blurb') || 'We collect the minimum necessary information to operate your account and trips. You can update your profile anytime or contact support for data questions.'}
              </Typography>
            </>
          )}
        </Box>

        {/* Edit Field Modal - Uber Style */}
        <Dialog
          open={editField !== null && editField !== 'language'}
          onClose={closeEditModal}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 0,
              boxShadow: 'none',
              maxWidth: 480,
              m: { xs: 0, sm: 2 },
              height: { xs: '100%', sm: 'auto' },
              maxHeight: { xs: '100%', sm: '90vh' },
            }
          }}
        >
          <Box sx={{ p: { xs: 3, sm: 5 }, pt: { xs: 6, sm: 8 } }}>
            {/* Title */}
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                fontSize: { xs: 28, sm: 36 },
                color: '#000',
                mb: 2,
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
              }}
            >
              {editField === 'name' && (t('name') || 'Name')}
              {editField === 'email' && (t('email') || 'Email')}
              {editField === 'mobile' && (t('phone_number') || 'Phone number')}
            </Typography>

            {/* Description */}
            <Typography
              variant="body1"
              sx={{
                color: '#6B7280',
                mb: 4,
                fontSize: 16,
                lineHeight: 1.5,
              }}
            >
              {editField === 'name' && (t('name_description') || "Your name helps drivers and riders identify you.")}
              {editField === 'email' && (t('email_description') || "You'll use this email for notifications and to recover your account.")}
              {editField === 'mobile' && (t('phone_description') || "You'll use this number to get notifications, sign in and recover your account.")}
            </Typography>

            {/* Input Label */}
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color: '#000',
                mb: 1,
                fontSize: 14,
              }}
            >
              {editField === 'name' && (t('full_name') || 'Full name')}
              {editField === 'email' && (t('email_address') || 'Email address')}
              {editField === 'mobile' && (t('phone_number') || 'Phone number')}
            </Typography>

            {/* Input Field */}
            <TextField
              autoFocus
              fullWidth
              variant="outlined"
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              placeholder={
                editField === 'name' ? (t('enter_name') || 'Enter your name') :
                editField === 'email' ? (t('enter_email') || 'Enter your email') :
                (t('enter_phone') || 'Enter your phone number')
              }
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                  fontSize: 16,
                  backgroundColor: '#F9FAFB',
                  '& fieldset': {
                    borderColor: '#E5E7EB',
                  },
                  '&:hover fieldset': {
                    borderColor: '#000',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#000',
                    borderWidth: 2,
                  },
                },
                '& .MuiOutlinedInput-input': {
                  py: 1.75,
                  px: 2,
                },
              }}
            />

            {/* Helper Text */}
            <Typography
              variant="body2"
              sx={{
                color: '#9CA3AF',
                mt: 1.5,
                fontSize: 14,
              }}
            >
              {editField === 'mobile' && (t('verification_code_sent') || 'A verification code will be sent to this number')}
              {editField === 'email' && (t('verification_email_sent') || 'A verification code will be sent to this email')}
            </Typography>

            {/* Update Button */}
            <Button
              onClick={() => { saveEditField(); formTopRef.current?.click(); }}
              fullWidth
              variant="contained"
              sx={{
                bgcolor: '#000',
                color: '#fff',
                borderRadius: 2,
                py: 1.75,
                mt: 4,
                textTransform: 'none',
                fontWeight: 600,
                fontSize: 16,
                boxShadow: 'none',
                '&:hover': {
                  bgcolor: '#1F2937',
                  boxShadow: 'none',
                }
              }}
            >
              {t('update') || 'Update'}
            </Button>

            {/* Cancel Link */}
            <Button
              onClick={closeEditModal}
              fullWidth
              sx={{
                color: '#6B7280',
                py: 1.5,
                mt: 1,
                textTransform: 'none',
                fontWeight: 500,
                fontSize: 14,
                '&:hover': {
                  bgcolor: 'transparent',
                  color: '#000',
                }
              }}
            >
              {t('cancel') || 'Cancel'}
            </Button>
          </Box>
        </Dialog>

        {/* Language Selection Modal */}
        <Dialog
          open={editField === 'language'}
          onClose={closeEditModal}
          PaperProps={{ sx: { borderRadius: 3, minWidth: 360 } }}
        >
          <DialogTitle sx={{ fontWeight: 700, fontSize: 20 }}>
            {t('select_language') || 'Select language'}
          </DialogTitle>
          <DialogContent sx={{ p: 0 }}>
            {multiLanguage && (
              <List>
                {Object.keys(multiLanguage).map((key, index) => (
                  <ListItemButton
                    key={key}
                    selected={langSelection === index}
                    onClick={() => {
                      handleLanguageSelect({ target: { value: index } });
                      closeEditModal();
                      setLoading(true);
                      completeSubmit();
                    }}
                    sx={{
                      py: 1.5,
                      px: 3,
                      '&.Mui-selected': { bgcolor: '#F3F4F6' }
                    }}
                  >
                    <ListItemText
                      primary={multiLanguage[key].langName}
                      primaryTypographyProps={{ fontWeight: langSelection === index ? 600 : 400 }}
                    />
                    {langSelection === index && <CheckCircleIcon sx={{ color: '#22C55E' }} />}
                  </ListItemButton>
                ))}
              </List>
            )}
          </DialogContent>
        </Dialog>

        {/* OTP Verification Dialog - Uber Style */}
        <Dialog
          open={otpCalled}
          onClose={handleClose}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 0,
              boxShadow: 'none',
              maxWidth: 480,
              m: { xs: 0, sm: 2 },
              height: { xs: '100%', sm: 'auto' },
              maxHeight: { xs: '100%', sm: '90vh' },
            }
          }}
        >
          <Box sx={{ p: { xs: 3, sm: 5 }, pt: { xs: 6, sm: 8 } }}>
            {/* Title */}
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                fontSize: { xs: 28, sm: 36 },
                color: '#000',
                mb: 2,
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
              }}
            >
              {t('enter_code') || 'Enter the code'}
            </Typography>

            {/* Description */}
            <Typography
              variant="body1"
              sx={{
                color: '#6B7280',
                mb: 4,
                fontSize: 16,
                lineHeight: 1.5,
              }}
            >
              {t('code_sent_description') || "We've sent a verification code to your phone or email. Enter it below to verify your identity."}
            </Typography>

            {/* Input Label */}
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                color: '#000',
                mb: 1,
                fontSize: 14,
              }}
            >
              {t('verification_code') || 'Verification code'}
            </Typography>

            {/* OTP Input */}
            <TextField
              autoFocus
              fullWidth
              variant="outlined"
              value={otp}
              onChange={updateOtp}
              placeholder="000000"
              inputProps={{
                maxLength: 6,
                style: { letterSpacing: 8, textAlign: 'center', fontSize: 24, fontWeight: 600 }
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                  fontSize: 24,
                  backgroundColor: '#F9FAFB',
                  '& fieldset': {
                    borderColor: '#E5E7EB',
                  },
                  '&:hover fieldset': {
                    borderColor: '#000',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#000',
                    borderWidth: 2,
                  },
                },
                '& .MuiOutlinedInput-input': {
                  py: 2,
                  px: 2,
                },
              }}
            />

            {/* Helper Text */}
            <Typography
              variant="body2"
              sx={{
                color: '#9CA3AF',
                mt: 1.5,
                fontSize: 14,
              }}
            >
              {t('didnt_receive_code') || "Didn't receive a code? Check your spam folder or try again."}
            </Typography>

            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                <CircularProgress sx={{ color: '#000' }} />
              </Box>
            ) : (
              <>
                {/* Verify Button */}
                <Button
                  onClick={handleVerify}
                  fullWidth
                  variant="contained"
                  sx={{
                    bgcolor: '#000',
                    color: '#fff',
                    borderRadius: 2,
                    py: 1.75,
                    mt: 4,
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: 16,
                    boxShadow: 'none',
                    '&:hover': {
                      bgcolor: '#1F2937',
                      boxShadow: 'none',
                    }
                  }}
                >
                  {t('verify') || 'Verify'}
                </Button>

                {/* Cancel Link */}
                <Button
                  onClick={handleClose}
                  fullWidth
                  sx={{
                    color: '#6B7280',
                    py: 1.5,
                    mt: 1,
                    textTransform: 'none',
                    fontWeight: 500,
                    fontSize: 14,
                    '&:hover': {
                      bgcolor: 'transparent',
                      color: '#000',
                    }
                  }}
                >
                  {t('cancel') || 'Cancel'}
                </Button>
              </>
            )}
          </Box>
        </Dialog>

        <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
      </Box>
  );
};

export default MyProfile;
